'use client'

import React from 'react'
import { ScrollAnimation } from '../ScrollAnimation'

interface HomePageClientProps {
  children: React.ReactNode
}

// Wrapper component to add scroll animations to server components
export function AnimatedSection({
  children,
  variant = 'fadeUp',
  delay = 0,
  amount,
  className,
}: {
  children: React.ReactNode
  variant?: 'fadeUp' | 'fadeDown' | 'fadeLeft' | 'fadeRight' | 'fade' | 'scale'
  delay?: number
  amount?: number
  className?: string
}) {
  return (
    <ScrollAnimation variant={variant} delay={delay} amount={amount} className={className}>
      {children}
    </ScrollAnimation>
  )
}

export function HomePageAnimations({ children }: HomePageClientProps) {
  return <>{children}</>
}
